import $ from 'jquery'
import {editMode} from "../supportFunctions/consts";

export function getPanelJSON() {
    return JSON.parse($('#panelInfoDropDownText').text());
}
export function checkEditMode() {
    return editMode
}